module.exports = __webpack_public_path__ + "img/product_fish.d6289b1.webp";